import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PostsService } from 'src/app/services/posts/posts.service';
import { TranslateConfigService } from 'src/app/services/translate-config.service';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-post-item',
  templateUrl: './post-item.component.html',
  styleUrls: ['./post-item.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule]
})
export class PostItemComponent {

  constructor(
    private postsService: PostsService,
    private router: Router,
    private translateService: TranslateConfigService
  ) { }
  @Input() obj:any
  @Input() isWeb: boolean = false;

  async selectObj(obj: any){
    await this.postsService.selectItem(obj);
    this.navigate('/details');
  }

  navigate(path: string){
    this.router.navigate([path]);
  }
}
